<template>
  <span v-if="!articleFeatureIcons.length" class="py-4">
    {{ $t('pdp.product_details_no_info') }}
  </span>
  <div
    v-if="articleFeatureIcons.length"
    class="flex items-center pt-3 text-sm font-normal leading-5 md:text-lg md:leading-6"
  >
    <span class="mr-1">{{ $t('pdp.product_details_functions.your') }} </span>
    <span class="mr-2 uppercase">
      <span class="font-bold">
        {{ $t('pdp.product_details_functions.plus') }}</span
      >:
    </span>
    <NuxtLazyHydrate>
      <ProductFunctionIcons :symbols="articleFeatureIcons" />
    </NuxtLazyHydrate>
  </div>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'
import { resolveFunctionIconSymbol } from '~/config/functionIcons'

const props = defineProps({
  product: {
    type: Object as PropType<Product | null>,
    default: () => null,
  },
})

const getPathWithoutExtension = (val: string) => {
  const idx = val.lastIndexOf('.')
  return idx === -1 ? val : val.slice(0, idx)
}

const articleFeatureIcons = computed(() => {
  const values = props.product?.attributes?.articleFeatureIcon?.values
  if (!values) {
    return []
  }
  const toSymbol = (raw: string | undefined) =>
    raw ? resolveFunctionIconSymbol(getPathWithoutExtension(raw)) : ''
  if (Array.isArray(values)) {
    return values
      .map((i) => toSymbol(i.label || (i as any).value))
      .filter((i) => Boolean(i))
  }
  return [toSymbol(values.label || (values as any).value)].filter((i) =>
    Boolean(i),
  )
})
</script>
